import { useGetFinancialProfile } from "api/trading/useGetFinancialProfile";
import { 
  useCanTradeByIBTags, 
  useCanTradeByJuridicalForm, 
  useGetSelectedPorfolio, 
  isBrokeragePortfolio 
} from "services/permissions/usePermission";
import { determineTradingType } from "utils/trading/tradingPermissions";
import { TradingContext, AccessRights } from "utils/trading/types";
import { useDetectActiveUserType } from "./useDetectActiveUserType";
import { useExtId } from "./useExtId";

export function useTradingContext(): TradingContext {
  const { isAnotherPrivateUser, isAnotherLegalUser } = useDetectActiveUserType();
  const canTradeByIBTags = useCanTradeByIBTags();
  const { canTrade: canTradeByJuridical, canTradeComplex } = useCanTradeByJuridicalForm();
  const selectedPortfolio = useGetSelectedPorfolio();
  const { extId } = useExtId();
  const { data: financialProfile } = useGetFinancialProfile(extId);

  const portfolioType = selectedPortfolio?.type?.code;
  const isBrokerage = isBrokeragePortfolio(selectedPortfolio);
  const classification = financialProfile?.contacts[0]?.classification?.code;
  
  // Access rights determination
  const accessRights: AccessRights = canTradeByIBTags ? AccessRights.FULL : AccessRights.VIEW;

  // Overall can trade (combines IB tags and juridical form checks)
  const canTrade = canTradeByIBTags && (canTradeByJuridical || !isAnotherLegalUser);

  // Determine trading type based on requirements
  const tradingType = determineTradingType({
    isAnotherPrivateUser,
    isAnotherLegalUser,
    portfolioType,
    accessRights,
    classification,
    canTradeComplex,
  });

  return {
    tradingType,
    isAnotherPrivateUser,
    isAnotherLegalUser,
    isBrokerage,
    portfolioType,
    accessRights,
    classification,
    canTrade,
    canTradeComplex,
    financialProfile,
  };
}
